import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraining = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 4.5 2 9l10 4.5L22 9 12 4.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 11v4.5c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V11" }),
		/* @__PURE__ */ _jsx("path", { d: "M22 9v5" })
	]
});
export { SvgTraining as ReactComponent };
